module.exports = __webpack_public_path__ + "static/media/sample.a2040809.csv";